import QRCode from 'qrcode';
import qrTemplateUrl from './assets/QRTemplate.png';
import qrMaskUrl from './assets/QRMask.png';

export async function renderGuestQrDataUrl(text, size = 320) {
  return QRCode.toDataURL(String(text || ''), {
    width: size,
    margin: 2,
    errorCorrectionLevel: 'M',
    color: { dark: '#000000', light: '#ffffff' },
  });
}

function loadImage(src) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = reject;
    img.src = src;
  });
}

function findWhiteBoundingBox(imageData, width, height, threshold = 200) {
  let minX = width;
  let minY = height;
  let maxX = 0;
  let maxY = 0;
  const { data } = imageData;

  for (let y = 0; y < height; y += 1) {
    for (let x = 0; x < width; x += 1) {
      const i = (y * width + x) * 4;
      const r = data[i];
      const g = data[i + 1];
      const b = data[i + 2];
      if (r >= threshold && g >= threshold && b >= threshold) {
        if (x < minX) minX = x;
        if (y < minY) minY = y;
        if (x > maxX) maxX = x;
        if (y > maxY) maxY = y;
      }
    }
  }

  if (maxX < minX) return null;
  return { x: minX, y: minY, width: maxX - minX + 1, height: maxY - minY + 1 };
}

export async function composeGuestQrWithTemplate(qrDataUrl) {
  const [template, mask, qr] = await Promise.all([
    loadImage(qrTemplateUrl),
    loadImage(qrMaskUrl),
    loadImage(qrDataUrl),
  ]);

  const width = template.naturalWidth;
  const height = template.naturalHeight;

  const maskCanvas = document.createElement('canvas');
  maskCanvas.width = width;
  maskCanvas.height = height;
  const maskCtx = maskCanvas.getContext('2d');
  maskCtx.drawImage(mask, 0, 0, width, height);
  const bbox = findWhiteBoundingBox(maskCtx.getImageData(0, 0, width, height), width, height);
  if (!bbox) throw new Error('QR mask region not found');

  const padding = Math.round(Math.min(bbox.width, bbox.height) * 0.06);

  const qrLayer = document.createElement('canvas');
  qrLayer.width = width;
  qrLayer.height = height;
  const qrCtx = qrLayer.getContext('2d');
  qrCtx.drawImage(mask, 0, 0, width, height);
  qrCtx.globalCompositeOperation = 'source-in';
  qrCtx.drawImage(
    qr,
    bbox.x + padding,
    bbox.y + padding,
    bbox.width - padding * 2,
    bbox.height - padding * 2,
  );

  const finalCanvas = document.createElement('canvas');
  finalCanvas.width = width;
  finalCanvas.height = height;
  const ctx = finalCanvas.getContext('2d');
  ctx.drawImage(template, 0, 0);
  ctx.drawImage(qrLayer, 0, 0);

  return finalCanvas.toDataURL('image/png');
}

export function downloadQrPng(dataUrl, filename = 'enterprise-guest-checkin-qr.png') {
  const anchor = document.createElement('a');
  anchor.href = dataUrl;
  anchor.download = filename;
  anchor.rel = 'noopener';
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
}

export async function downloadGuestQrWithTemplate(qrDataUrl, filename = 'enterprise-guest-checkin-qr.png') {
  const dataUrl = await composeGuestQrWithTemplate(qrDataUrl);
  downloadQrPng(dataUrl, filename);
}
